import type { ReactNode } from "react";
import { BookOpen, Map, Shield, ShoppingBag, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { fr } from "../../i18n/fr";
import { Logo } from "./Logo";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="content-layer mt-16 border-t border-iron-300/55 bg-obsidian-500">
      <div className="h-1 bg-blood-500" />
      <div className="safe-x mx-auto grid max-w-[1500px] gap-10 py-10 md:grid-cols-[1.35fr_repeat(3,1fr)]">
        <div className="border-r-0 border-iron-400/45 md:border-r md:pr-10">
          <Logo />
          <p className="mt-4 max-w-sm text-sm leading-6 text-parchment-200/60">
            Un portail vivant pour suivre le royaume, préparer son aventure et retrouver la communauté d'Etheria.
          </p>
        </div>

        <FooterCol icon={<Shield className="h-4 w-4" />} title="Jouer">
          <FooterLink to="/guide">Guide du royaume</FooterLink>
          <FooterLink to="/connexion">Connexion</FooterLink>
          <FooterLink to="/inscription">Créer un compte</FooterLink>
          <FooterLink to="/vote">Voter</FooterLink>
        </FooterCol>

        <FooterCol icon={<BookOpen className="h-4 w-4" />} title="Découvrir">
          <FooterLink to="/wiki">Encyclopédie</FooterLink>
          <FooterLink to="/wiki/metiers">Métiers</FooterLink>
          <FooterLink to="/patchnotes">Actualités</FooterLink>
          <FooterLink to="/monde">Monde vivant</FooterLink>
        </FooterCol>

        <FooterCol icon={<Users className="h-4 w-4" />} title="Communauté">
          <FooterLink to="/guildes">Guildes</FooterLink>
          <FooterLink to="/classements">Classements</FooterLink>
          <FooterLink to="/carte">Carte en direct</FooterLink>
          <FooterLink to="/boutique"><ShoppingBag className="mr-1 inline h-3.5 w-3.5" />Boutique</FooterLink>
        </FooterCol>
      </div>

      <div className="border-t border-iron-400/45 bg-black/30">
        <div className="safe-x mx-auto flex max-w-[1500px] flex-col gap-2 py-4 text-xs text-parchment-200/45 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {fr.brand.name}. {fr.footer.droits}</p>
          <p className="flex items-center gap-2"><Map className="h-3.5 w-3.5 text-arcane-300" />{fr.footer.fanContent}</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ icon, title, children }: { icon: ReactNode; title: string; children: ReactNode }) {
  return (
    <div>
      <h4 className="mb-4 flex items-center gap-2 border-b border-iron-400/45 pb-2 font-display text-xs font-semibold uppercase tracking-[0.12em] text-arcane-100">
        {icon}{title}
      </h4>
      <ul className="space-y-2">{children}</ul>
    </div>
  );
}

function FooterLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <li>
      <Link to={to} className="text-sm text-parchment-200/60 transition-colors hover:text-arcane-100">
        {children}
      </Link>
    </li>
  );
}
